import { store } from '../redux/store';
import { openSessionModal } from '../redux/user/user_actions';
import { axiosInstance } from './apiSevices';
import { loginUrl, refreshTokenUrl } from './urls';

const { dispatch } = store;

export const interceptor = () => {
  let refreshPromise;
  const id = axiosInstance.interceptors.response.use(
    (res) => res,
    async (err) => {
      const message = err.response?.data?.message;
      const status = err.response?.status;
      const originalRequest = err.config;

      // Login errors belong to the login form. Never refresh a refresh request.
      if (!originalRequest || originalRequest.url === loginUrl || originalRequest.url === refreshTokenUrl) {
        return Promise.reject(err);
      }

      const needsRefresh = status === 401 || (status === 403 && (message === 'No token provided.' || message === 'Token expired.'));
      if (needsRefresh && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
          // Share one refresh across simultaneous dashboard requests. The browser
          // sends the refresh cookie, including when it is HttpOnly.
          if (!refreshPromise) {
            refreshPromise = axiosInstance.post(refreshTokenUrl, {}, { withCredentials: true })
              .finally(() => { refreshPromise = null; });
          }
          await refreshPromise;
        } catch (refreshError) {
          openSessionModal(dispatch);
          return Promise.reject(refreshError);
        }
        return axiosInstance(originalRequest);
      }

      if (needsRefresh || message === 'Session has expired') {
        openSessionModal(dispatch);
      }
      return Promise.reject(err);
    },
  );
  return () => axiosInstance.interceptors.response.eject(id);
};
